import React from 'react';
import Slider from 'react-slick';

const BrandOne = ({ ...restProps }) => {

  const settings = {
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  };

  const style = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 15px',
    height: '100%',
    width: '100%',
    backgroundColor: '#fff',
  };
  return (
    <div {...restProps}>
      <div className="container">
        <div className="sec-line-wrap">
          <div className="sec-line"></div>
          <h2 className="sec-title2">Our Trusted Clients</h2>
          <div className="sec-line"></div>
        </div>
        <Slider className="row text-center" {...settings}>
          <div style={style}><img src="images/brand/br-efg.jpg" alt="brands" style={{ maxHeight: 96 }} /></div>
          <div  style={style}><img src="images/brand/br-contactcars.jpg" alt="brands" style={{ maxHeight: 96 }} /></div>
          <div style={style}><img src="images/brand/br-valu.jpg" alt="brands" style={{ maxHeight: 96 }} /></div>
          <div style={style}><img src="images/brand/br-elabd.png" alt="brands" style={{ maxHeight: 96 }} /></div>
          <div style={style}><img src="images/brand/br-elitessolutions.jpg" alt="brands" style={{ maxHeight: 96 }} /></div>
          <div style={style}><img src="images/brand/br-balad.jpg" alt="brands" style={{ maxHeight: 96 }} /></div>
          <div style={style}><img src="images/brand/br-furn.jpg" alt="brands" style={{ maxHeight: 96 }} /></div>
          <div style={style}><img src="images/brand/br-moqawalat.jpg" alt="brands" style={{ maxHeight: 96 }} /></div>
          <div style={style}><img src="images/brand/br-alaqaar.jpg" alt="brands" style={{ maxHeight: 96 }} /></div>
          <div style={style}><img src="images/brand/br-jamjoom.jpg" alt="brands" style={{ maxHeight: 96 }} /></div>
          <div style={style}><img src="images/brand/br-jointscope.jpg" alt="brands" style={{ maxHeight: 96 }} /></div>
        </Slider>
      </div>
    </div>
  );
}

export default BrandOne;